
let packageInfo = require('../../package.json')

// 项目名称
const prefix = packageInfo.name;
const LocalStorage = {
  keys: {
    uuid: 'uuid',
    systemUser: 'system-user',
    processData:'process-data'
  }
};

/**
 * @description 存储 localStorage 值
 * @param {String} name localStorage name
 * @param {String} value localStorage value
 */
LocalStorage.set = function(name = "default", value = "") {
  localStorage.setItem(`${prefix}-${process.env.NODE_ENV}-${name}`, value && JSON.stringify(value) || "");
};

/**
 * @description 拿到 localStorage 值
 * @param {String} name localStorage name
 */
LocalStorage.get = function(name = "default") {
  let getValue = localStorage.getItem(`${prefix}-${process.env.NODE_ENV}-${name}`)
  return getValue && JSON.parse(getValue) || '';
};


/**
 * @description 删除 localStorage
 * @param {String} name localStorage name
 */
LocalStorage.remove = function(name = "default") {
  return localStorage.removeItem(`${prefix}-${process.env.NODE_ENV}-${name}`);
};


/**
 * @description 移除所有的 localStorage 项
 */
LocalStorage.clear = function() {
  return localStorage.clear();
};

export default LocalStorage;